import { __extends, __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames, UitkContextWrapper } from 'uitk-react-utils';
import { UitkButton } from './uitk-button.esm.js';

var UitkTertiaryButton = /** @class */ (function (_super) {
    __extends(UitkTertiaryButton, _super);
    function UitkTertiaryButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkTertiaryButton.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, alignLabelToContent = _b.alignLabelToContent, inverse = _b.inverse, props = __rest(_b, ["className", "alignLabelToContent", "inverse"]);
        var cssClassNames = classNames("".concat(UitkButton.baseClassName, "-tertiary"), className, (_a = {},
            _a["".concat(UitkButton.baseClassName, "-tertiary-align-with-content-").concat(alignLabelToContent)] = alignLabelToContent,
            _a["".concat(UitkButton.baseClassName, "-tertiary-inverse")] = inverse,
            _a));
        return (React.createElement(UitkContextWrapper, null, function (context) { return React.createElement(UitkButton, __assign({}, props, { className: cssClassNames, "data-context": context })); }));
    };
    UitkTertiaryButton.displayName = 'UitkTertiaryButton';
    return UitkTertiaryButton;
}(React.Component));

export { UitkTertiaryButton };
